import React, { useCallback, useContext } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { usePathname } from 'src/hooks/router-hooks';
import { useDispatch } from 'react-redux';
import { useDeps } from 'src/hooks/useDeps';

import { useMagicLink } from '../../hooks/useMagicLink';

import classes from './HeaderControls.scss';
import { HeaderContext } from './Header';

export const AccountIcon = ({ whiteIcons }: { whiteIcons: boolean }) => {
    const { components, dispatch } = useMagicLink();
    const { isSignedIn } = useContext(HeaderContext);

    return (
        <>
            {!isSignedIn && <SignedOut dispatch={dispatch} whiteIcons={whiteIcons} />}
            {isSignedIn && (
                <Link
                    className={classnames(classes.headerControl, classes.headerControlUser, 'headerControl')}
                    to="/customer/account"
                >
                    <div className={classes.imageContainer}>
                        <img
                            className={classes.headerControlImageDesktop}
                            src={require('../../../static/icons/login-register.svg')}
                            alt="my account icon"
                        />
                        <img
                            className={classes.headerControlImageMobile}
                            src={
                                whiteIcons
                                    ? require('../../../static/icons/login-register-mobile-white.svg')
                                    : require('../../../static/icons/login-register-mobile.svg')
                            }
                            alt="my account icon"
                        />
                        <img className={classes.loggedInCheck} src={require('../../../static/icons/ok.svg')} alt="" />
                    </div>

                    <span className={classes.headerControlText}>Account</span>
                    <span className={classes.headerControlContent}>My Account</span>
                </Link>
            )}
            {components}
        </>
    );
};

/**
 * This is extracted so that we can change functionality
 * based on which page the user is on.
 *
 * If the user is on ANY customer page, we will NOT show the modals, ever
 *
 */
const SignedOut: React.FC<{ dispatch: (evt: { kind: 'sign-in' }) => void; whiteIcons: boolean }> = (props) => {
    const { dispatch, whiteIcons } = props;
    const pathname = usePathname();
    const reduxDispatch = useDispatch();
    const { push, paths } = useDeps();
    const onClick = useCallback(() => {
        if (pathname.indexOf('/customer/') === 0) {
            reduxDispatch(push(paths.customer.login));
        } else {
            dispatch({ kind: 'sign-in' });
        }
    }, [dispatch, pathname, paths, reduxDispatch, push]);
    return (
        <button
            className={classnames(
                classes.headerControl,
                classes.headerControlUser,
                classes.headerControAccount,
                'headerControl',
            )}
            type="button"
            data-test-id="AccountIcon_login"
            onClick={onClick}
        >
            <img
                className={classes.headerControlImageDesktop}
                src={require('../../../static/icons/login-register.svg')}
                alt="my account icon"
            />
            <img
                className={classes.headerControlImageMobile}
                src={
                    whiteIcons
                        ? require('../../../static/icons/login-register-mobile-white.svg')
                        : require('../../../static/icons/login-register-mobile.svg')
                }
                alt="my account icon"
            />
            <span className={classes.headerControlText}>Account</span>
            <span className={classes.headerControlContent}>Login / Register</span>
        </button>
    );
};
